var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back",on:{"click":_vm.click}},[_c('IconBack',{staticClass:"icon-back"}),_c('span',[_vm._v(" "+_vm._s(_vm.$t("wv_global_01"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }